import { Phone, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";

export const CTABanner = () => {
  const { t } = useLanguage();

  return (
    <section data-testid="cta-banner" className="py-16 bg-gradient-to-r from-[#003A4B] to-[#1B5E6B] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#C89D4B]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full blur-2xl"></div>

      <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center relative z-10">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-white mb-4">
          {t.cta.title}
        </h2>
        <p className="text-white/80 text-lg mb-8 max-w-xl mx-auto">
          {t.cta.description}
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <a href="#booking">
            <Button
              data-testid="cta-book-btn"
              className="bg-[#C89D4B] hover:bg-[#B38A3E] text-white rounded-full px-8 py-6 text-lg font-semibold shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all"
            >
              <Calendar className="w-5 h-5 mr-2" />
              {t.cta.bookFree}
            </Button>
          </a>
          <a href="tel:+16093153943">
            <Button
              data-testid="cta-call-btn"
              variant="outline"
              className="rounded-full px-8 py-6 text-lg border-2 border-white text-white hover:bg-white/10 transition-all font-semibold"
            >
              <Phone className="w-5 h-5 mr-2" />
              {t.cta.callNow}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};
